import { AxiosResponse } from 'axios';
import { APIError } from '../types/types';

export const sanitizeURL = (url: string): string => {
  if (!url) {
    return '';
  }

  const badURLRegex = RegExp('^((https)|(http)):/{3,}');
  const isBadURL = badURLRegex.test(url);

  if (isBadURL) {
    return 'https://' + url.replace(badURLRegex, '');
  }

  return url;
};

export const getErrorMessage = (response?: AxiosResponse<APIError>) => {
  if (response?.status === 400 && response?.data.errors[0].code) {
    return response?.data.errors[0].message;
  }

  return null;
};

export function parseApiError(err: any) {
  const raw = err?.data?.errors?.[0]?.error;

  let parsed: any = {};
  if (typeof raw === 'string') {
    try {
      parsed = JSON.parse(raw);
    } catch {
      return { message: raw };
    }
  }

  if (raw && typeof raw === 'object') {
    parsed = raw;
  }
  return {
    message: parsed.message || 'Unknown error',
    ttl: parsed.ttl,
    supportContact: parsed.supportContact,
  };
}
